type PropHeroLogoProps = {
  className?: string;
};

function PropHeroLogo({ className }: PropHeroLogoProps) {
  const customAuthDomain =
    import.meta.env.VITE_CUSTOM_AUTH_DOMAIN ??
    "https://custom-auth.dev.prophero.com";

  return (
    <img
      src={`${customAuthDomain}/logos/Logo-PropHero.svg`}
      alt="PropHero"
      className={`h-5 md:h-8 w-auto ${className ?? ""}`}
      decoding="async"
      loading="eager"
    />
  );
}

export default PropHeroLogo;
